"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["className", "disabled", "isText"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "startAdornmentWrapper": "muCAvj",
  "icon": "ZmCBk5",
  "text": "j5kwQP",
  "disabled": "v7in1D"
};
var getColorClassName = function getColorClassName(_ref) {
  var disabled = _ref.disabled,
    isText = _ref.isText;
  if (disabled) {
    return styles.disabled;
  }
  return isText ? styles.text : styles.icon;
};
var StartAdornmentWrapper = function StartAdornmentWrapper(_ref2) {
  var className = _ref2.className,
    disabled = _ref2.disabled,
    isText = _ref2.isText,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.startAdornmentWrapper, getColorClassName({
      disabled: disabled,
      isText: isText
    }))
  }));
};
StartAdornmentWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  isText: _propTypes["default"].bool
} : {};
var _default = exports["default"] = StartAdornmentWrapper;